import { render } from "./Inquiry.vue?vue&type=template&id=9ad17d96&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=9ad17d96&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad17d96"]])

export default __exports__